
// aos js
AOS.init({
  duration: 1200,
});
// mobile version
AOS.init({disable: 'mobile'});
	AOS.init({
	disable: function() {
	  var maxWidth = 800;
	  return window.innerWidth < maxWidth;
	}
});

// header ticker slider
$('#header-ticker-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-angle-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});

/* search.js
 ========================================================*/
 var searchToggle = $('.open-search'),
 inputAnime = $(".form-search"),
 body = $('body');

searchToggle.on('click', function(event){
 event.preventDefault();
 if ( !inputAnime.hasClass('active') ) {
   inputAnime.addClass('active');
 } else {
   inputAnime.removeClass('active');     
 }
});

body.on('click', function(){
 inputAnime.removeClass('active');
});
$('.close-btn') .on('click', function(){
 inputAnime.removeClass('active');
});

var elemBinds = $('.open-search, .form-search');
elemBinds.bind('click', function(e) {
 e.stopPropagation();
});

/* End search.js
========================================================*/

// partners slider js

$('#banner-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});



/*#### woman-dresses slider js start ###*/ 

$('#woman-dresses-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});


/*#### woman-dresses slider js start ###*/ 

$('#men-category-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});


/*#### books slider js start ###*/ 

$('#books-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});

// brands slider js
$('#brands-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,
  //infinite: false,
  speed: 8000,
  slidesToShow: 9,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }

  ]
});

/*####### Shop page js*/ 
$(document).ready(function () {
    $(".category_head .plusminus").click(function () {
        let head = $(this).parent(); // go up to .accordion_head
        let body = head.next(".category_nav_wrap"); // get its sibling body

        if (body.is(':visible')) {
            body.slideUp(300);
            $(this).text('+');
        } else {
            $(".category_nav_wrap").slideUp(300); // close all
            $(".plusminus").text('+');         // reset all plus
            body.slideDown(300);               // open this one
            $(this).text('-');                 // set minus
        }
    });
});

$(".mobile-filter-tigger").click(function () {
  $(".left-sidebar").slideToggle();
});

/*####### Shop page js end*/